import optimizedFaviconB2bUrl from 'url:../assets/favicon-b2b.png?as=webp&width=51';
import optimizedFaviconB2cUrl from 'url:../assets/favicon-b2c.png?as=webp&width=51';
import optimizedLogoB2bUrl from 'url:../assets/logo-b2b.png?as=webp&width=150';
import optimizedLogoB2cUrl from 'url:../assets/logo-b2c.png?as=webp&width=150';

export class NavComponent extends HTMLElement {
    static observedAttributes = ['active-page', 'theme'];

    constructor() {
        super();
    }

    connectedCallback() {
        const activePage = this.getAttribute('active-page');
        const theme = this.getAttribute('theme');

        const faviconUrl = theme === 'b2b' ? optimizedFaviconB2bUrl : optimizedFaviconB2cUrl;
        const logoUrl = theme === 'b2b' ? optimizedLogoB2bUrl : optimizedLogoB2cUrl;

        this.innerHTML = `
        <nav class="navbar">
            <a href="/" class="logo__wrapper" aria-label="logo">
                <img class="icon" alt="Ikona logo" src="${faviconUrl}" width="51" height="51"
                     fetchpriority="high">
                <img class="logo" alt="logo" src="${logoUrl}" width="150" height="35"
                     fetchpriority="high">
            </a>
            <div class="navbar__menu--desktop">
                <a class="navbar__menu-item ${activePage === 'start' ? 'active' : ''}" href="/" aria-label="start">
                    <span>Start</span>
                    <div class="underline"></div>
                </a>
                <a class="navbar__menu-item ${activePage === 'hurtownia' ? 'active' : ''}" href="/hurtownia" aria-label="hurtownia">
                    <span>Hurtownia drewna</span>
                    <div class="underline"></div>
                </a>
                <a class="navbar__menu-item ${activePage === 'domy' ? 'active' : ''}" href="/domy" aria-label="domy">
                    <span>Domy</span>
                    <div class="underline"></div>
                </a>
                <a class="navbar__menu-item ${activePage === 'realizacje' ? 'active' : ''}" href="/realizacje" aria-label="realizacje">
                    <span>Realizacje</span>
                    <div class="underline"></div>
                </a>
                <a class="navbar__menu-item ${activePage === 'blog' ? 'active' : ''}" href="/blog" aria-label="blog">
                    <span>Blog</span>
                    <div class="underline"></div>
                </a>
                <a class="cmp__button cta sm" href="/kontakt" aria-label="kontakt">
                    <span>Kontakt</span>
                    <div class="underline"></div>
                </a>
            </div>

            <div class="navbar__menu--mobile" x-data="{ open: false }">
                <button class="hamburger" type="button" tabindex="0" aria-label="Menu" @click="open = !open">
                    <span class="hamburger__line"></span>
                    <span class="hamburger__line"></span>
                    <span class="hamburger__line"></span>
                </button>

                <div class="hamburger__menu" x-show="open" x-transition.duration.200ms @click.away="open = false">
                    <a class="navbar__menu-item active" href="/" aria-label="start">
                        <span>Start</span>
                        <div class="underline"></div>
                    </a>
                    <a class="navbar__menu-item" href="/hurtownia" aria-label="hurtownia">
                        <span>Hurtownia drewna</span>
                        <div class="underline"></div>
                    </a>
                    <a class="navbar__menu-item" href="/domy" aria-label="domy">
                        <span>Domy</span>
                        <div class="underline"></div>
                    </a>
                    <a class="navbar__menu-item" href="/realizacje" aria-label="realizacje">
                        <span>Realizacje</span>
                        <div class="underline"></div>
                    </a>
                    <a class="navbar__menu-item" href="/blog" aria-label="blog">
                        <span>Blog</span>
                        <div class="underline"></div>
                    </a>
                    <a class="navbar__menu-item" href="/kontakt" aria-label="kontakt">
                        <span>Kontakt</span>
                        <div class="underline"></div>
                    </a>
                </div>
            </div>
        </nav>
        `;
    }
}

customElements.define('bc-nav', NavComponent);